module.exports = __webpack_public_path__ + "img/boundary-add-hover.f3d42b71.svg";